// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_html2canvas_dist_html2canvas_js":"716d48c815301fef","node_modules_dompurify_dist_purify_js":"c4c6d3592d44fd19","node_modules_canvg_lib_index_es_js":"9080cfaaa68aab9c"}[chunkId] + ".js";
};